<div class="col itemsContainer d-print-block-visible">
  <div class="row report-controls">
      <div class="col-2">
          <input class="btn btn-primary" type="button" (click)="goBack()" value="Back" />
      </div>
      <div class='col-8 text-center'>
          <h1 class="h1-responsive report-name text-center">{{asset.title}}</h1>
      </div>
      <div class="col-2 ml-auto">
      </div>
  </div>
  <div class="row d-none d-print-block-visible">
      <div class='col-12 text-center'>
          <h1 class="h1-responsive report-name text-center">{{asset.title}}</h1>
      </div>
  </div>
  <div class="row" *ngIf="!hasLoaded">
      <div class="col">
          <p class="alert alert-warning">
              <app-spin-icon></app-spin-icon> Loading...
          </p>
      </div>
  </div>
  <p class="text-center offset-2 col-8"><i>{{asset.description}}</i></p>
  <p *ngIf="asset.tags?.length > 0" class="text-center offset-2 col-8"><i>Tags: {{asset.tags.join(', ')}}</i></p>
  <dac-exercise class="card card-body" *ngIf="shouldDisplayExercise()" [exercise]="asset" [hideHeaders]="disableAsset" [disabled]="disableAsset">
  </dac-exercise>
  <dac-article class="card card-body" *ngIf="shouldDisplayArticle()" [article]="asset" [hideHeaders]="disableAsset" [disabled]="disableAsset">
  </dac-article>
</div>


// WEBPACK FOOTER //
// ./src/app/library-assets/admin-view-asset/admin-view-asset.component.html